import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class QRCodeModel extends BaseModel {
  data = null;

  rules = {
    amount: 'required|min_value:1',
  };

  attributeHints = {};

  attributeLabels = {
    amount: i18n.t('Amount'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
